import api from '@/services/api/api'
import TokenService from '@/services/auth/TokenService'

class AuthService {
  login (login) {
    return api
      .post('/auth/authenticate', {
        userName: login.userName,
        password: login.password
      })
      .then(response => {
        if (response.data.accessToken) {
          TokenService.setLogin(response.data)
        }
        return response.data
      })
  }

  loginLink (linkLogin) {
    return api
      .post('/auth/authenticate-link', linkLogin)
      .then(response => {
        if (response.data.accessToken) {
          TokenService.setLogin(response.data)
        }
        return response.data
      })
  }

  loginReLink (linkLogin) {
    return api
      .post('/auth/authenticate-re-link', linkLogin)
      .then(response => {
        if (response.data.accessToken) {
          TokenService.setLogin(response.data)
        }
        return response.data
      })
  }

  logout () {
    TokenService.removeLogin()
  }
}

export default new AuthService()



// WEBPACK FOOTER //
// ./src/services/auth/AuthenticationService.js